import styled from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';

export const ProgressBarWrapper = styled.div`
  padding: 18px;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CountFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  width: 100%;
`;

export const Count = styled.div`
  color: ${darkgrey};
  font-family: Lato;
  font-size: 28px;
  font-weight: 700;
  line-height: 30px;
`;

export const MaxCount = styled.div`
  color: ${grey};
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
`;

export const CountWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Label = styled.div`
  color: ${grey};
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
`;

export const PitchCount = styled.div`
  color: ${grey};
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
`;
